import { render } from "./StandardSisDataMaterial.vue?vue&type=template&id=65b5579b"
import script from "./StandardSisDataMaterial.vue?vue&type=script&lang=js"
export * from "./StandardSisDataMaterial.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__